import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useDocumentTitle from '../useDocumentTitle';
import axios from 'axios';
import { Box, Flex, Spinner, Container, Grid, Image } from '@chakra-ui/react';
import GameBanner from '../components/game/GameBanner';
import Title from '../components/game/Title';
import DownloadCard from '../components/game/DownloadCard';
import ImageSlider from '../components/common/ImageSlider';
import InfoCard from '../components/game/InfoCard';
import Description from '../components/game/Description';
import Requirements from '../components/game/Requirements';

const Game = () => {
  const [currentGameData, setCurrentGameData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

useEffect(() => {
  const fetchCurrentGame = async () => {
    try {
      const response = await fetch('./Games.json');
      const games = await response.json();
      const currentGame = games.find(game => game.id === Number(params.gameId));
      setCurrentGameData(currentGame);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching game data:', error);
      setIsLoading(false);
    }
  };

  fetchCurrentGame();
}, [params.gameId]);

  useDocumentTitle(
    currentGameData.title ? `${currentGameData.title}` : 'Game Grid'
  );

  return isLoading ? (
    <Box
      w='100vw'
      h='100vh'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <Spinner size='xl' />
    </Box>
  ) : (
    <Box>
      <Flex direction='column' gap='10'>
        <GameBanner currentGameData={currentGameData} />
        <Container maxW={['90vw', null, null, '1200px']} p='0'>
          <Grid templateColumns={['100%', null, null, '1.5fr 1fr']} gap='4'>
            <Title currentGameData={currentGameData} />
            <DownloadCard currentGameData={currentGameData.repository_link} />
            {currentGameData.screenshots.length === 0 ? (
              <Image
                src={currentGameData.thumbnail}
                rounded='md'
                fit='cover'
                w='100%'
                h='100%'
              />
            ) : (
              <ImageSlider images={currentGameData.screenshots} />
            )}
            <InfoCard currentGameData={currentGameData} />
            <Description currentGameData={currentGameData} />
            <Requirements currentGameData={currentGameData} />
          </Grid>
        </Container>
      </Flex>
    </Box>
  );
};

export default Game;
